<template>
  <div class="d-flex flex-wrap align-middle justify-end mt-5">
    <v-btn
      @click="setQuotePaymentType(null)"
      :block="$vuetify.breakpoint.xs ? true : false"
      :disabled="isQuotePaymentLoading"
      class="mr-2 mb-2"
      color="grey darken-1"
      elevation="0"
      large
      text
    >
      {{ $t('quote.action.goBack') }}
    </v-btn>

    <v-btn
      @click="$emit('submit')"
      :block="$vuetify.breakpoint.xs ? true : false"
      :loading="isQuotePaymentLoading"
      color="primary"
      elevation="0"
      large
    >
      {{ $t('quote.action.makePayment') }}
    </v-btn>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'QuotePaymentActions',

  computed: {
    ...mapGetters(['isQuotePaymentLoading']),
  },

  methods: {
    ...mapMutations(['setQuotePaymentType']),
  },
}
</script>
